import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    standalone: true,
    selector: 'global-home-icon',
    templateUrl: './icon.component.html',
    imports: [CommonModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.ShadowDom,
})
export class IconComponent {
    @Input() svg!: string;
    @Input() size = 20;

    constructor(private domSanitizer: DomSanitizer) {}

    get icon(): SafeHtml {
        return this.domSanitizer.bypassSecurityTrustHtml(this.svg);
    }
}
